
import $ from 'jquery';

$('[data-read-more]').each(function () {
    (element, index, array) => {
        element.addEventListener("click", function() {
            if (element.getAttribute('aria-expanded') !== 'true') {
                element.innerHTML = "{{'app.pane_text_media.read_less'|trans}}";
            } else {
                element.innerHTML = "{{'app.pane_text_media.read_more'|trans}}";
            }
        });
    }
});
